module.exports = __webpack_public_path__ + "img/Group 1077five.5e000468.png";